// @flow
import * as React from 'react';
import { Link } from 'react-router';

type Props = {
  activeTab: string,
  locationId: string | number,
  currentOrgId: string | number,
  context: string
};

class LocationTabSidebar extends React.Component<Props> {
  render() {
    const { activeTab, currentOrgId, locationId, context } = this.props;
    return (
      <div className="industries-sidebar-section">
        <ul>
          <li className={activeTab === 'LocationDetails' ? 'active' : 'not'}>
            <Link to={`/${context}/${currentOrgId}/sub-accounts/${locationId}`}>
              Details
            </Link>
          </li>
          {locationId !== 'new' && (
            <li className={activeTab === 'LocationUsers' ? 'active' : 'not'}>
              <Link
                to={`/${context}/${currentOrgId}/sub-accounts/${
                  locationId
                }/userList`}
              >
                Users
              </Link>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

export default LocationTabSidebar;



// WEBPACK FOOTER //
// ./src/containers/location/LocationTabSidebar.js